// Box zone icons copied from the inventory-manager app so the admin matches it:
// Pickup zone = the yellow gift-box (sellable stock), Warehouse zone = the blue
// warehouse illustration (reserve stock).

const PICKUP_BOX_SVG = `<svg width="100%" height="100%" viewBox="0 0 45 44" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M21.8785 0.142142L2.17572 9.65388C1.92865 9.77316 1.77173 10.0232 1.77173 10.2975V33.7025C1.77173 33.9768 1.92874 34.2268 2.17572 34.3461L21.8785 43.8579C22.2712 44.0474 22.7289 44.0474 23.1215 43.8579L42.8243 34.3461C43.0714 34.2268 43.2283 33.9768 43.2283 33.7025V10.2975C43.2283 10.0232 43.0713 9.77316 42.8243 9.65388L23.1215 0.142142C22.7289 -0.0473502 22.2712 -0.0473502 21.8785 0.142142Z" fill="#FFE17D"/>
  <path d="M1.89058 9.90627C1.81547 10.0207 1.77173 10.1553 1.77173 10.2975V33.7025C1.77173 33.9768 1.92874 34.2268 2.17572 34.3461L21.8785 43.8578C22.0748 43.9526 22.2874 43.9999 22.5 43.9999V19.8557L1.89058 9.90627Z" fill="#FFC350"/>
  <path d="M43.1094 9.90627C43.1846 10.0207 43.2283 10.1553 43.2283 10.2975V33.7025C43.2283 33.9768 43.0713 34.2268 42.8243 34.3461L23.1215 43.8578C22.9252 43.9526 22.7126 44 22.5 44V19.8557L43.1094 9.90627Z" fill="#FFD164"/>
  <path d="M7.66779 32.4549C7.5638 32.4549 7.45767 32.4319 7.3579 32.3837L4.31597 30.9152C3.96002 30.7435 3.81134 30.3163 3.98305 29.961C4.15406 29.6057 4.58263 29.4577 4.93721 29.6281L7.97914 31.0967C8.33509 31.2684 8.48377 31.6956 8.31206 32.0509C8.18926 32.3062 7.93377 32.4549 7.66779 32.4549Z" fill="#FFE17D"/>
  <path d="M10.4676 30.6324C10.3636 30.6324 10.2575 30.6094 10.1577 30.5613L4.32012 27.7434C3.96486 27.5717 3.8155 27.1445 3.9872 26.7892C4.15822 26.4346 4.58747 26.286 4.94137 26.4563L10.7788 29.2742C11.1341 29.4459 11.2835 29.8731 11.1118 30.2283C10.989 30.4837 10.7336 30.6324 10.4676 30.6324Z" fill="#FFF6D8"/>
  <path d="M36.1253 13.2664L15.4434 3.27508L9.99152 5.91766L30.7198 15.9245L36.1253 13.2664Z" fill="#FF8087"/>
  <path d="M30.7198 15.9245V23.6766C30.7198 23.9401 30.9953 24.113 31.2326 23.9985L35.7213 21.8316C35.9684 21.7123 36.1253 21.4622 36.1253 21.1879V13.2665L30.7198 15.9245Z" fill="#E6646E"/>
</svg>`;

const WAREHOUSE_BOX_SVG = `<svg width="100%" height="100%" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6 58V30C6 18 17 10 32 10s26 8 26 20v28z" fill="#E0E7FD"/>
  <path d="M6 58V30C6 18 17 10 32 10s26 8 26 20v28" stroke="#A9BBF6" stroke-width="2.5" stroke-linejoin="round" stroke-linecap="round"/>
  <rect x="14" y="40" width="13" height="18" rx="1.5" fill="#B7C6F8"/>
  <rect x="29" y="46" width="11" height="12" rx="1.5" fill="#CBD6FB"/>
  <rect x="42" y="36" width="9" height="22" rx="1.5" fill="#A9BBF6"/>
  <path d="M14 40h13v18M29 46h11v12M42 36h9v22" stroke="#8EA3F2" stroke-width="1.4" stroke-linejoin="round" stroke-linecap="round" fill="none"/>
</svg>`;

interface BoxZoneIconProps {
  zone: "Pickup" | "Warehouse";
  size?: number;
}

const BoxZoneIcon = ({ zone, size = 28 }: BoxZoneIconProps) => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      width: size,
      height: size,
      flexShrink: 0,
    }}
    dangerouslySetInnerHTML={{
      __html: zone === "Warehouse" ? WAREHOUSE_BOX_SVG : PICKUP_BOX_SVG,
    }}
  />
);

export default BoxZoneIcon;
